module.exports = __webpack_public_path__ + "img/1122106277.9018acea.jpg";